export default function (value) {
  if (value === 0) return '0 guests';
  if (value === 1) return `${value} guest`;
  return `${value} guests`;
}
